import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { StarProIcon } from '../../../../shared/Icons';
import { ButtonUpgradePro } from './ButtonUpgradePro';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';

export function CampaignDashPackageReminder({ defaultShown = true }) {
    const { t } = useTranslation();
    const [isShownReminder, setIsShownReminder] = useState(defaultShown);
    const { company } = useSelector((state: IAllStates) => state.auth.user);

    const handleCloseReminder = () => {
        localStorage.setItem('reminderClosingTime', new Date().toISOString());
        setIsShownReminder(false);
    };

    return (
        <>
            {isShownReminder && company?.package.isShownToUser && (
                <Card className="border-primary">
                    <div className="dash-package-close-icon" onClick={handleCloseReminder}>
                        <img src="/icons/closeIcon.svg" alt="Close icon" />
                    </div>
                    <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center me-3">
                                <StarProIcon classes="mr-3" width="70" height="33" />
                                <div>
                                    <h5 className="mb-0">{t('brand.package.dashBasicTitle')}</h5>
                                    <span className="text-muted">{t('brand.package.dashBasicDesc')}</span>
                                </div>
                            </div>
                            <ButtonUpgradePro variant="outline-primary" />
                        </div>
                    </Card.Body>
                </Card>
            )}
        </>
    );
}
